
import { Button } from "@/components/ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Eye, History, Trash2 } from "lucide-react";

// Define status labels for display
const STATUS_LABELS = {
  'Bekliyor': 'Bekliyor',
  'Iletisime Gecildi': 'İletişime Geçildi',
  'Gorüsme Yapildi': 'Görüşme Yapıldı',
  'Satis Yapildi': 'Satış Yapıldı',
  'Gelmedi': 'Gelmedi',
  'Iptal': 'İptal'
};

interface TrialSessionsTabProps {
  trialSessions: any[];
  getStatusColor: (status: string) => string;
  onStatusChange: (trial: any) => void;
  onHistoryView: (trialId: string) => void;
  onDelete: (trial: any) => void;
}

export const TrialSessionsTab = ({
  trialSessions,
  getStatusColor,
  onStatusChange,
  onHistoryView,
  onDelete,
}: TrialSessionsTabProps) => {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Tarih</TableHead>
          <TableHead>İsim</TableHead>
          <TableHead>Email</TableHead>
          <TableHead>Telefon</TableHead>
          <TableHead>Görüşme Tarihi</TableHead>
          <TableHead>Durum</TableHead>
          <TableHead>İşlemler</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {trialSessions.map((trial) => (
          <TableRow key={trial.id}>
            <TableCell>{new Date(trial.created_at).toLocaleDateString('tr-TR')}</TableCell>
            <TableCell>{trial.name_surname}</TableCell>
            <TableCell>{trial.email}</TableCell>
            <TableCell>{trial.phone}</TableCell>
            <TableCell>{new Date(trial.meeting_date).toLocaleString('tr-TR')}</TableCell>
            <TableCell>
              <span className={`px-2 py-1 rounded-full text-sm ${getStatusColor(trial.status)}`}>
                {STATUS_LABELS[trial.status as keyof typeof STATUS_LABELS] || 'Bekliyor'}
              </span>
            </TableCell>
            <TableCell>
              <div className="flex gap-2">
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={(e) => {
                    e.stopPropagation();
                    onStatusChange(trial);
                  }}
                >
                  <Eye className="h-4 w-4" />
                </Button>
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={(e) => {
                    e.stopPropagation();
                    onHistoryView(trial.id);
                  }}
                >
                  <History className="h-4 w-4" />
                </Button>
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={(e) => {
                    e.stopPropagation();
                    onDelete(trial);
                  }}
                >
                  <Trash2 className="h-4 w-4" />
                </Button>
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
